import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { ExternalDashboardNotificationsDTO } from './getDashboardNotifications';

const saveDashboardNotifications = async ({
  dashboardId,
  ...data
}: ExternalDashboardNotificationsDTO & { dashboardId: string }) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/notifications`,
    method: 'post',
    data,
  };

  await axios.request(config);
};

export default saveDashboardNotifications;
